import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["frontPreview", "backPreview", "messagePreview", "giverName", "giftList", "recipient"]
  static values = {
    previewUrl: String,
    selectedGiverKey: String
  }

  connect() {
    // Listen for template/style changes
    this.element.addEventListener("change", this.handleChange.bind(this))

    // Load initial preview if a giver is selected
    if (this.selectedGiverKeyValue) {
      this.loadPreview()
    }
  }

  handleChange(event) {
    const target = event.target
    if (target.name === "template_key" || target.name === "message_style") {
      this.loadPreview()
    }
  }

  selectGiver(event) {
    event.preventDefault()
    const giverKey = event.currentTarget.dataset.giverKey

    // Update selection UI
    this.recipientTargets.forEach(el => {
      el.classList.remove("ring-2", "ring-violet-500", "bg-violet-50")
    })
    event.currentTarget.classList.add("ring-2", "ring-violet-500", "bg-violet-50")

    this.selectedGiverKeyValue = giverKey
    this.loadPreview()
  }

  async loadPreview() {
    if (!this.selectedGiverKeyValue) return

    const templateKey = this.getSelectedValue("template_key") || "gift_thank_you"
    const messageStyle = this.getSelectedValue("message_style") || "formal"

    const url = new URL(this.previewUrlValue, window.location.origin)
    url.searchParams.set("giver_key", this.selectedGiverKeyValue)
    url.searchParams.set("template_key", templateKey)
    url.searchParams.set("message_style", messageStyle)

    try {
      const response = await fetch(url, {
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      if (!response.ok) throw new Error("Preview failed")

      const data = await response.json()
      this.updatePreview(data)
    } catch (error) {
      console.error("Failed to load preview:", error)
    }
  }

  updatePreview(data) {
    if (this.hasFrontPreviewTarget) {
      this.frontPreviewTarget.srcdoc = data.front_html
    }
    if (this.hasBackPreviewTarget) {
      this.backPreviewTarget.srcdoc = data.back_html
    }
    if (this.hasMessagePreviewTarget) {
      this.messagePreviewTarget.textContent = data.message
    }
    if (this.hasGiverNameTarget) {
      this.giverNameTarget.textContent = data.giver_name
    }
    if (this.hasGiftListTarget) {
      this.giftListTarget.innerHTML = data.gifts.map(g =>
        `<span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800">${g}</span>`
      ).join(" ")
    }
  }

  getSelectedValue(name) {
    const input = this.element.querySelector(`input[name="${name}"]:checked`)
    return input ? input.value : null
  }
}
